import React, {useState, useEffect} from 'react'; 
import DataGrid, {
    Column,
    FilterRow, 
    ColumnChooser,
    Paging,     Scrolling
    , Export, Summary, TotalItem
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import './TesvikRapor.scss';
import {parseDate} from "../../utils/Utils";

const TesvikRapor = (props) => {
 

    

    const [store, setStore] = useState(null);

    useEffect(() => {
        setStore(getStore());
    }, [])




    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                 //
                const request = new Request("/tesvikRaporIslemleri/getKayitListByRapor/"+ props.data.domainId +"/" + props.data.donemId , "GET");

                return request.run()
                .then(response => {
                    if (response.data) {

                        response.data.data.map(d => {
                            d.hesapDonemTar = parseDate(d.hesapDonemTar);
                            d.donemBas = parseDate(d.donemBas);
                            d.donemBit = parseDate(d.donemBit);
                            d.iseBaslamaTar = parseDate(d.iseBaslamaTar);
                            d.istenAyrilisTar = parseDate(d.istenAyrilisTar);
                        });
                        return {
                            data: response.data.data,
                            totalCount: response.data.total,
                            summary: 0,
                            groupCount: 0
                        };
                    } else {
                        return []

                    }
                });
            }
        });
    }
    function kanunStyle(data) {

        if( data.row.data.beyanKanunNo !== data.row.data.kanunNo){
         //return   <div style={{backgroundColor:  '#5C95C5'}}>{data.value}</div>
         //return  <div style={{backgroundColor:  '#5C95C5'}}> <b>{data.value}</b></div>
        //  if(!data.component.isRowSelected(data.rowIndex)){
            //  data.cellElement.style.backgroundColor ='#5C95C5'
             return  <div style={{backgroundColor:  '#F6BB42', margin:0}}> <b>{data.value}</b></div>
         // }

        }
        return data.value;
    }

    function siraRender(data) {
        return (data.rowIndex +1);// <b>{(data.rowIndex +1)}</b> ;
    }

    return (
        <div >
            {/* <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{marginLeft: "10px"}}>
                </div>
            </div> */}

            <DataGrid
                className={props.gridClassName ? props.gridClassName : "tesvikRaporListesiGrid"}
                width="100%"
                //height="500px"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{ mode: 'single', deferred: true }}
            //remoteOperations={true}
            >
                <FilterRow visible={true} />
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />

                {/* <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={10} /> */}

                <Column width={30} caption={'Sıra'} dataType="number" visible={true} cellRender={siraRender} />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'tesvikDetayId'} width={90} caption={'tesvikDetayId'} dataType="number" visible={false} />
                <Column dataField={'personelId'} width={90} caption={'personelId'} dataType="number" visible={false} />


                <Column dataField={'personelTcKimlik'} width={90} caption={'Tck No'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'personelAdi'} minWidth={90} width={90} caption={'Adı'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'personelSoyadi'} minWidth={90} width={90} caption={'Soyadı'} dataType="string" mappingType="String" visible={true} />

                <Column dataField="iseBaslamaTar" width={70} caption={'İşe baş. tar.'} dataType="date" format="dd.MM.yyyy" visible={false} />
                <Column dataField="istenAyrilisTar" width={70} caption={'İşten Ayrılış tar.'} dataType="date" format="dd.MM.yyyy" visible={false} />
                <Column dataField={'belgeTuru'} width={40} caption={'Belge Çeşidi'} dataType="String" visible={true} />
                <Column dataField={'beyanKanunNo'} width={70} caption={'Beyan Kanun No'} dataType="String" visible={true} cellRender={kanunStyle} />
                <Column dataField="primDestegi" width={70} caption={'Pirim Desteği'} dataType="number" visible={true} />
                <Column dataField={'meslekAdi'} minWidth={50} width={50} caption={'Meslek Adı'} dataType="string" mappingType="String" visible={false} />
                <Column dataField={'meslekKodu'} minWidth={50} width={70} caption={'Meslek Kodu'} dataType="string" mappingType="String" visible={false} />

                <Column dataField="hesapDonemTar" width={70} caption={'Hesap-Dönem'} dataType="date" format="yyyy/MM" visible={false} />

                <Column dataField="kanunNo" width={70} caption={'Önerilen Kanun No'} dataType="string" visible={true} cellRender={kanunStyle} />
                <Column dataField="donemBas" width={70} caption={'Başlangıç'} dataType="date" format="yyyy/MM" visible={false} />
                <Column dataField="donemBit" width={70} caption={'Bitiş'} dataType="date" format="yyyy/MM" visible={false} />

                <Column dataField="primDestegiYuzde5Haric" width={70} caption={'Pirim Desteği'} dataType="number" visible={true} />
                <Column dataField="tesvikSgkOnay" width={30} caption={'Onay'} dataType="boolean" visible={true} />


                <Column dataField={'ucret'} width={60} caption={'Prime Esas Kazanç (ikramiye ve ücret toplamı)'} dataType="number" visible={true} />
                <Column dataField={'ikramiye'} width={60} caption={'İkramiye'} dataType="number" visible={true} />
                <Column dataField={'gun'} width={40} caption={'Gün'} dataType="number" visible={true} />
                <Column dataField={'ortalamaGunSayisi'} width={40} caption={'Ortalama Gün (7252)'} dataType="Number" visible={false} />
                <Column dataField={'kanunsuzBildirlecekGunSayisi'} width={40} caption={'Kanunsuz Bilgrilecek Gün'} dataType="Number" visible={false} />



                <Column dataField="ilaveOlunacakSayi" width={70} caption={'Ortalama'} dataType="string" visible={true} />
                <Column dataField={'calisanSayi6111'} width={60} caption={'Ç.Sayı - 6111'} dataType="number" visible={true} />
                <Column dataField={'calisanSayi7103'} width={60} caption={'Ç.Sayı - 7103'} dataType="number" visible={true} />


                <Summary>
                    <TotalItem
                        column="id"
                        summaryType="count" />
                    {/* <TotalItem
              column="OrderDate"
              summaryType="min"
              customizeText={this.customizeDate} />
            <TotalItem
              column="SaleAmount"
              summaryType="sum"
              valueFormat="currency" /> */}
                </Summary>

            </DataGrid>

        </div>
    )
}

export default TesvikRapor;
